module.exports = __webpack_public_path__ + "img/bg-lines.c8828ef0.svg";